"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTeam = void 0;
var typeorm_1 = require("typeorm");
var BilateralTrade_entity_1 = require("./BilateralTrade.entity");
var OpenTrade_entity_1 = require("./OpenTrade.entity");
var OpenTradeComplete_entity_1 = require("./OpenTradeComplete.entity");
var TeamAssetAdjustment_entity_1 = require("./TeamAssetAdjustment.entity");
var BaseTeam = /** @class */ (function () {
    function BaseTeam() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], BaseTeam.prototype, "teamID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BaseTeam.prototype, "label", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null, select: false }),
        __metadata("design:type", Number)
    ], BaseTeam.prototype, "passcode", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BaseTeam.prototype, "color", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], BaseTeam.prototype, "type", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return BilateralTrade_entity_1.BilateralTrade; }, function (bilateralTrade) { return bilateralTrade.offeringTeam; }),
        __metadata("design:type", Array)
    ], BaseTeam.prototype, "offeringTeamID", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return BilateralTrade_entity_1.BilateralTrade; }, function (bilateralTrade) { return bilateralTrade.receivingTeam; }),
        __metadata("design:type", Array)
    ], BaseTeam.prototype, "receivingTeamID", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return OpenTrade_entity_1.OpenTrade; }, function (openTrade) { return openTrade.offeringTeam; }),
        __metadata("design:type", Array)
    ], BaseTeam.prototype, "offeringTeam", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return OpenTradeComplete_entity_1.OpenTradeComplete; }, function (openTrade) { return openTrade.receivingTeam; }),
        __metadata("design:type", Array)
    ], BaseTeam.prototype, "receivingTeam", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return TeamAssetAdjustment_entity_1.TeamAssetAdjustment; }, function (teamAssetAdjustment) { return teamAssetAdjustment.team; }),
        __metadata("design:type", Array)
    ], BaseTeam.prototype, "assetAdjustments", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null }),
        __metadata("design:type", Number)
    ], BaseTeam.prototype, "currentRound", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null }),
        __metadata("design:type", Number)
    ], BaseTeam.prototype, "portfolio", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: null }),
        __metadata("design:type", String)
    ], BaseTeam.prototype, "roundEndTime", void 0);
    BaseTeam = __decorate([
        (0, typeorm_1.Entity)({ name: 'teams' })
    ], BaseTeam);
    return BaseTeam;
}());
exports.BaseTeam = BaseTeam;
//# sourceMappingURL=Team.entity.js.map